import { render, staticRenderFns } from "./OperatorsLogs.vue?vue&type=template&id=1895c3a8&"
import script from "./OperatorsLogs.vue?vue&type=script&lang=js&"
export * from "./OperatorsLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports